import { Skeleton } from "primereact/skeleton";



const RenderLoading = (itemsNumber:number) => {
  
    const options = [];

    for (let i = 0; i <= itemsNumber; i++) {
      if(i===0)options.push( <Skeleton className="mb-5"  height="3rem" />);
      options.push( <Skeleton className="mb-3"  height="8rem" />);
    }
    return options;
      
} 

export default RenderLoading;